import type { IncidentListSortKey } from '@prerender/diagnostics-api';
import type { ReactNode } from 'react';

import type { IncidentListSort } from './incidentListParams';

type IncidentColumnHeaderProps = {
  label: string;
  sortKey?: IncidentListSortKey;
  sort: IncidentListSort | null;
  onSort: (key: IncidentListSortKey) => void;
  filter?: ReactNode;
};

type AriaSort = 'ascending' | 'descending' | 'none';

const ariaSortOf = (sort: IncidentListSort | null, sortKey: IncidentListSortKey): AriaSort => {
  if (sort === null || sort.key !== sortKey) return 'none';

  return sort.direction === 'asc' ? 'ascending' : 'descending';
};

function IncidentColumnHeader({ label, sortKey, sort, onSort, filter }: IncidentColumnHeaderProps) {
  return (
    <th aria-sort={sortKey === undefined ? undefined : ariaSortOf(sort, sortKey)}>
      <span className="diagnostics-column-header">
        {sortKey === undefined ? (
          label
        ) : (
          <button type="button" className="diagnostics-sort-button" onClick={() => onSort(sortKey)}>
            {label}
          </button>
        )}
        {filter}
      </span>
    </th>
  );
}

export default IncidentColumnHeader;
